import { encryptMnemonic, decryptMnemonic } from '@stacks/encryption';
import { triplesecDecrypt } from './triplesec';
export function decrypt(dataBytes, password) {
    return decryptMnemonic(dataBytes, password, triplesecDecrypt);
}
export function encrypt(phrase, password) {
    return encryptMnemonic(phrase, password);
}
//# sourceMappingURL=encryption.js.map